export default "__VITE_ASSET__0U3US8Wo__"